export default __webpack_public_path__ + "static/media/__dev_only.ac96ad81.scss";